import { render, staticRenderFns } from "./PaginaAdminJefeDCABI.vue?vue&type=template&id=daf97b6e"
import script from "./PaginaAdminJefeDCABI.vue?vue&type=script&lang=js"
export * from "./PaginaAdminJefeDCABI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports